<template>
  <div class="row" style="height: 100%; width: 1900px; position: relative">
    <LkLeftPanelBit />
    <div></div>
    <div id="lk_exit" @click="exitLk">
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.333 1H18.7775C19.3668 1 19.9321 1.23413 20.3488 1.65087C20.7655 2.06762 20.9997 2.63285 20.9997 3.22222V18.7778C20.9997 19.3671 20.7655 19.9324 20.3488 20.3491C19.9321 20.7659 19.3668 21 18.7775 21H14.333"
          stroke="#222222"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.77734 16.5556L14.3329 11L8.77734 5.44446"
          stroke="#222222"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.3333 11H1"
          stroke="#222222"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div id="lk_right_panel_points"></div>
  </div>
</template>
<script>
import LkLeftPanelBit from '../components/LkLeftPanelBit'
import {useMyStorage} from "@/store/global";

export default {
  middleware: "auth",
  components:{
    LkLeftPanelBit
  },
  name:"PositionsPage",
  setup(){
    const store=useMyStorage()
    return{
      store
    }
  },
  methods: {
    async exitLk() {
     // await this.$auth.logout(/* .... */);
      this.store.logout()
    },
  },
};
</script>
<style>
#lk_right_panel_points {
  position: absolute;
  right: 23px;
  top: 23px;
  width: 159px;
  height: 100%;
  overflow: hidden;
  background-image: url("data:image/svg+xml;utf8,<svg width='159' height='26' viewBox='0 0 159 26' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='53.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='79.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='1.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='105.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='27.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='131.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='157.5' cy='1.5' r='1.5' fill='%23E0E0E0'/></svg>");
  background-repeat: repeat-y;
  margin-bottom: -23px;
}
</style>